module.exports = __webpack_public_path__ + "img/f_4.1935dde5.jpg";